module.exports = __webpack_public_path__ + "static/img/ikonaPrezentacja-ON.e88197bf.png";